import router from '@/router'
import attributes from '@/components/pages/main-pages/settings/attributes/attributes.vue'
// import templates from '@/components/pages/main-pages/settings/templates/templates.vue'
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  components: {
    attributes
    // templates
  },
  computed: {
    ...mapGetters('user', ['isSuperAdmin']),
    tabs: function () {
      return [
        {
          name: 'attributes',
          title: 'Attributes',
          visible: true
        },
        // {
        //   name: 'templates',
        //   title: 'Templates'
        // },
        {
          name: 'workflows',
          title: 'Workflows',
          visible: this.isSuperAdmin
        },
        {
          name: 'tags',
          title: 'Tags',
          visible: this.isSuperAdmin
        },
        {
          name: 'gdpr',
          title: 'GDPR',
          visible: this.isSuperAdmin
        }
      ]
    },
    ...mapState('settings', ['activeTab'])
  },
  methods: {
    ...mapMutations('settings', ['setActiveTab']),
    isActive: function (tabName) {
      return tabName === this.activeTab
    }
  },
  beforeMount() {
    this.setActiveTab(router.currentRoute.name)
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/settings.js